import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@mui/material';
import { CheckCircle, Cancel } from '@mui/icons-material';
import outWardService from '../services/outWardService';
import packageService from '../services/packageService';
import { useSelector } from 'react-redux';

const PaymentStatusPage = () => {
  const [token, setToken] = useState(null);
  const [status, setStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const authUserId = useSelector((state) => state?.auth?.user?.id);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const tokenParam = searchParams.get('token');
    const statusParam = searchParams.get('status');
    const paymentStatus = statusParam?.toLowerCase() === 'true';

    if (tokenParam) {
      setToken(tokenParam);
      setStatus(paymentStatus);
    }

    const getPaymentStatus = async () => {
      if (paymentStatus && tokenParam != null) {

        try {
          setIsLoading(true);
          const iyzicoResult = await outWardService.paymentTokenStatus("Iyzico", tokenParam);
          if (iyzicoResult?.data?.status) {
            const packageDetail = await packageService.fetchPackage(iyzicoResult?.data?.data?.paymentId);

            if (packageDetail.status) {
              const userPackageDetail = packageDetail.data.data[0];

              //const userPackageControl = await packageService.fetchUserPackage(iyzicoResult?.data?.data?.paymentId,authUserId);
              //if (userPackageControl.data.data[0] == null) {
              try{
                const today = new Date();
                const oneYearLater = new Date();
                oneYearLater.setFullYear(today.getFullYear() + 1);
                const userPackage = {
                  userId: authUserId,
                  packageDetailId: userPackageDetail?.id,
                  amount: userPackageDetail?.package?.salePrice,
                  startDate: today,
                  endDate: oneYearLater,
                };
                await packageService.addPackage(userPackage);
                await new Promise(resolve => setTimeout(resolve, 2000));
                window.location.href = '/';
              }catch{

              }
             
             // }

            }
          }
        } catch (error) {
          setError('Ödeme durumu kontrol edilirken bir hata oluştu.');
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    getPaymentStatus();
  }, [authUserId]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-gray-600">Yükleniyor...</div>
      </div>
    );
  }

  return (

      <Card sx={{mt:5}} className="max-w-md w-full mx-4 mt-5">
        <CardContent className="flex flex-col items-center p-6 text-center">
          { status ? (
            <>
              <CheckCircle className="w-16 h-16 text-green-500 mb-4" />
              <h1 className="text-2xl font-bold text-green-700 mb-2">
                Ödeme Başarılı
              </h1>
              <p className="text-gray-600">
                İşleminiz başarıyla tamamlandı. Lütfen çıkış yapıp tekrar giriş yapınız.
              </p>
            </>
          ) : (
            <>
              <Cancel sx={{ fontSize: 64, color: '#ef4444', marginBottom: 2 }} />
              <h1 className="text-2xl font-bold text-red-700 mb-2">
                Ödeme Başarısız
              </h1>
              <p className="text-gray-600">
                İşleminiz tamamlanamadı. Lütfen daha sonra tekrar deneyiniz.
              </p>
            </>
          )}
        </CardContent>
      </Card>
    
  );
};

export default PaymentStatusPage;